import axios from 'axios'
import storage from './storage'
import { Message } from 'element-ui';
import { Loading } from 'element-ui';
axios.defaults.withCredentials = true;
var loadingInstance;

let baseURL;

if (process.env.VUE_APP_API_URL == 'development') {
    baseURL = window.Global.baseURL
} else {
    if (process.env.VUE_APP_API_URL == 'test') {
        baseURL = window.Global.baseURL
    } else {
        baseURL = window.Global.baseURL
    }
}

const request = axios.create({
    baseURL: baseURL
})

request.interceptors.request.use(config => {
    var parten = new RegExp('login');
    var isLoginPage = parten.test(location.href);
    var token = storage.getSession('token') ? storage.getSession('token') : '';
    var ConversationID = storage.getSession('ConversationID') ? storage.getSession('ConversationID') : '';
    if (!isLoginPage) {
        loadingInstance = Loading.service({
            lock: true,
            text: '数据加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    }
    config.headers.Token = token;
    config.headers.ConversationID = ConversationID;
    config.headers.SourceName = 'DataCenter';
    return config;
}, error => {
    console.log(error)
    if(loadingInstance) {
        loadingInstance.close();
    }
    
    return Promise.reject(error)
})

request.interceptors.response.use(res => {
    if (!res.data.iserror) {
        if (loadingInstance) {
            loadingInstance.close();
        }
        return Promise.resolve(res.data)
    } else {
        if (res.data.errorcode === 40002 || res.data.errorcode === 40003) {
            Message.error({
                showClose: true,
                message: '登录超时，请重新登录',
            });
            storage.removeSession('token');
            setTimeout(() => {
                location.href = '#/login';
            }, 2000)
           
        } else if (res.data.errorcode === 40004) {
            Message.error({
                showClose: true,
                message: res.data.errormsg,
                duration: 0
            });
            
        } else {
            Message.error({
                showClose: true,
                message: res.data.errormsg,
            });
            
        }
        if (loadingInstance) {
            loadingInstance.close();
        }
        return Promise.reject(res.data)
    }
}, error => {
    if (loadingInstance) {
        loadingInstance.close();
    }
    Message.error({
        showClose: true,
        message: '网络错误，请稍后重试',
    });
    return Promise.reject(error)
})

const http = {
    post(url, data, options) {
        var o = Object.assign({
            loading: true,
            error: true
        }, options)
        return request({
            url: url,
            data: data,
            method: 'post',
        })
    },
    get(url, data) {
        return request({
            url: url,
            params: data,
            method: 'get'
        })
    }
}

export default http